import { useMemo } from "react";
import {
	AuthenticationGroupDetailsAccount,
	AuthenticationGroupDetailsSession,
} from "@cofano/coastguard2-frontend-client";
import CoastguardSessionSelectAccount from "./CoastguardSessionSelectAccount";
import { Box } from "@mui/material";

export type SessionSelectProps = {
	sessions: AuthenticationGroupDetailsSession[];
	currentSessionUuid: string | null;
	switchSession: (sessionUuid: string) => void;
	logoutSession: (sessionUuid: string) => void;
	hideSingleAccountDetails: boolean;
};

type Account = {
	key: string;
	account: AuthenticationGroupDetailsAccount;
	impersonator: AuthenticationGroupDetailsAccount | null;
	sessions: AuthenticationGroupDetailsSession[];
};

const CoastguardSessionSelect = (props: SessionSelectProps) => {

	const accounts = useMemo(() => {
		const accountMap = props.sessions.reduce((map, session) => {
			const accountKey = `${session.account.uuid}${session.impersonator != null ? `_${session.impersonator.uuid}` : ""}`;

			const existing = map.get(accountKey);
			if (existing) {
				existing.sessions.push(session);
			} else {
				map.set(accountKey, {
					key: accountKey,
					account: session.account,
					impersonator: session.impersonator,
					sessions: [ session ],
				});
			}

			return map;
		}, new Map<string, Account>());

		return [ ...accountMap.values() ];
	}, [ props.sessions ]);

	return (
		<Box sx={{
			display: "grid",
			gridColumn: "auto",
			gridGap: 2,
			overflowY: "auto",
			flex: "1 1 auto",
			minHeight: 0,
		}}>
			{accounts.map((account) => (
				<CoastguardSessionSelectAccount
					key={account.key}
					account={account.account}
					impersonator={account.impersonator}
					sessions={account.sessions}
					currentSessionUuid={props.currentSessionUuid}
					switchSession={props.switchSession}
					logoutSession={props.logoutSession}
					hideAccountDetails={props.hideSingleAccountDetails && accounts.length === 1}
				/>
			))}
		</Box>
	);
};

export default CoastguardSessionSelect;
